import request from '@/utils/request'

const baseUrlSimpleClassZhihuishu = 'https://simple-class.zhihuishu.com/simple-class'

/**
 * @description: 保存聊天记录
 * @param {*} params
 * @return {*}
 */
const saveChatRecord = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/app/im/saveChatRecord/v100`,
    method: 'post',
    params,
  })
}

/**
 * @description: 获取用户直播禁言列表
 * @param {any} params
 * @return {*}
 */
const getForbidChatUsers = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/student/forbidChatUsers`,
    method: 'get',
    params
  })
}

/**
 * @description: 禁言/解禁接口 用户禁言
 * @param {*} params
 * @return {*}
 */
const forbidChat = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/student/forbidChat`,
    method: 'get',
    params
  })
}

/**
 * @description: 获取聊天记录
 * @param {object} params
 * @return {*}
 */
const getChatRecords = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/app/im/getChatRecords/v100`,
    method: 'post',
    params,
  })
}

export default {
  getChatRecords,
	forbidChat,
  getForbidChatUsers,
  saveChatRecord
}
